import { useFormikContext } from 'formik';
import InlineButtonPanel from '@RHEnvironmental/pattern-library/dist/js/components/InlineButtonPanel';
import InputContainer from '@RHEnvironmental/pattern-library/dist/js/components/InputContainer';
import React from 'react';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import Toggle from '@RHEnvironmental/pattern-library/dist/js/components/Toggle';
import AnchorLink from '@RHEnvironmental/pattern-library/dist/js/components/AnchorLink';
import { Box } from '@chakra-ui/react';
import { localise } from '../../../../services/lang/lang';
const ShareInspectionForm = (props) => {
    const { values, isSubmitting, handleSubmit, setFieldValue } = useFormikContext();
    return (React.createElement("form", null,
        React.createElement(InputContainer, null,
            React.createElement(Box, { "data-testid": "share_inspection_form__share_enabled_toggle" },
                React.createElement(Toggle, { className: "mt-4", checked: values.share_enabled, onClick: () => {
                        if (isSubmitting)
                            return;
                        setFieldValue('share_enabled', !values.share_enabled);
                        handleSubmit();
                    } })),
            React.createElement("div", { className: "mt-4", "data-testid": "share_inspection_form_link_or_text" }, values.share_enabled ? (React.createElement(AnchorLink, { "data-testid": "share_inspection_form_link", onClick: () => {
                    props.onClose();
                    window.open(props.shareUrl);
                } }, localise('VIEW_SHARED_INSPECTION'))) : (localise('SHARE_INSPECTION_LINK')))),
        React.createElement(InlineButtonPanel, null,
            React.createElement(Button, { "data-testid": "share_inspection_form__done_button", onClick: props.onClose, disabled: isSubmitting }, localise('DONE')))));
};
export default ShareInspectionForm;
